import React from 'react'
import { Trans } from 'react-i18next'

/** End of tour step */
export const EndOfTourStep: React.FC = () => {
  return <Trans i18nKey={'emobility.tour.end-of-tour'} components={{ strong: <strong /> }} />
}
